import { render } from "./EmailConfig.vue?vue&type=template&id=418e8d0e&scoped=true"
import script from "./EmailConfig.vue?vue&type=script&lang=js"
export * from "./EmailConfig.vue?vue&type=script&lang=js"

import "./EmailConfig.vue?vue&type=style&index=0&id=418e8d0e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bmark-kid/bmark-kid-manage-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-418e8d0e"]])

export default __exports__